import PropTypes from 'prop-types';

const SearchInputPropType = {
  onChange: PropTypes.func.isRequired,
};

export default SearchInputPropType;
